/** Сторона кнопок −/+ — §29: 32×32. Точного токена нет, компонент-специфичная геометрия. */
export const STEPPER_BUTTON_SIZE = '32px'
export const STEPPER_VALUE_MIN_WIDTH = '14px'
